import { SectionDetails } from '@/app/types/marketing/SectionDetails';
import FeatureLandingPage from '@/components/feature-landing-page/FeatureLandingPage';
import {
  ClockIcon,
  DocumentDuplicateIcon,
  ArrowDownIcon,
  ArrowUpOnSquareStackIcon,
  BoltIcon,
  DocumentPlusIcon,
  PlayCircleIcon,
  PrinterIcon
} from '@heroicons/react/24/solid';
import heroImage from '@/public/ai-study-guide-hero.png';
import overviewImage from '@/public/ai-study-guide-overview.png';
import tutorialImage from '@/public/ai-study-guide-tutorial.png';

const overviewSection = {
  miniText: 'Master Your Material',
  title: 'Instant Study Guides',
  image: overviewImage,
  description:
    'Create personalized study guides directly from your files. Export to Word or PDF, and print out your guides for offline study.',
  features: [
    {
      name: 'Upload any file.',
      description:
        'Upload pdfs, notes, presentations, and images to generate a personalized study guide with AI-suggested focus areas.',
      icon: DocumentDuplicateIcon
    },
    {
      name: 'Download Word Document.',
      description:
        'Download your study guides as Word documents for easy editing and sharing.',
      icon: ArrowDownIcon
    },
    {
      name: 'Download PDF.',
      description:
        'Every study guide can be downloaded as a pdf to ensure you can access it anywhere.',
      icon: DocumentPlusIcon
    },
    {
      name: 'Print your study guide.',
      description:
        'Print out your study guides to review them whenever you like, even without a device.',
      icon: PrinterIcon
    },
    {
      name: 'Instant Access.',
      description:
        'Generate study guides in seconds, ensuring you have what you need right when you need it.',
      icon: BoltIcon
    },
    {
      name: 'Always available.',
      description:
        'Once generated, your study guides will remain available for whenever you need them.',
      icon: ClockIcon
    }
  ]
};

const tutorialSection = {
  miniText: 'Get Started',
  title: 'How It Works',
  image: tutorialImage,
  description:
    'Creating study guides is simple and straightforward so you can get right back to learning.',
  features: [
    {
      name: 'Upload your file(s).',
      description:
        'Upload your notes, presentations, PDFs or images to generate a comprehensive study guide.',
      icon: ArrowUpOnSquareStackIcon
    },
    {
      name: 'Customize and generate.',
      description:
        'Choose focus areas, complexity level, length, and add custom requirements before generating.',
      icon: PlayCircleIcon
    },
    {
      name: 'Download or Print.',
      description:
        'Export your study guide to a Word document or PDF, or print it out for offline study.',
      icon: PrinterIcon
    }
  ]
};

export default function _PdfToFlashcards() {
  return (
    <FeatureLandingPage
      heroImage={heroImage}
      analyticsName="home_study_guides"
      overviewSection={overviewSection}
      tutorialSection={tutorialSection}
      heroMiniTitle="AI Study Guides"
      heroTitle="Generate personalized study guides from any file"
      heroImageUrl="/ai-study-guide-hero.png"
      heroDescription="Upload your notes, presentations, or PDFs and create rich study guides with AI-suggested focus areas, custom complexity levels, and tailored content. Export, print, and study anywhere."
    />
  );
}
